import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

interface LoginProps {
  onNavigate?: () => void;
}

const Login = ({ onNavigate }: LoginProps) => {
  const { isAuthenticated, logout, user } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleLogout = () => {
    logout();
    setIsDropdownOpen(false);
    onNavigate?.();
  };

  const handleNavClick = () => {
    setIsDropdownOpen(false);
    onNavigate?.();
  };

  return (
    <div className="relative">
      {!isAuthenticated ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="flex items-center gap-8"
        >
          <Link
            to="/uye-ol"
            onClick={handleNavClick}
            className="text-gray-300 hover:text-white transition-colors font-sans relative pb-1 after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-full after:origin-center after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300 after:bg-white inline-flex items-center gap-2"
          >
            <svg
              className="w-5 h-5 transition-colors duration-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
              />
            </svg>
            Üye Ol
          </Link>
          <Link
            to="/giris-yap"
            onClick={handleNavClick}
            className="text-gray-300 hover:text-white transition-colors font-sans relative pb-1 after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-full after:origin-center after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:duration-300 after:bg-white inline-flex items-center gap-2"
          >
            <svg
              className="w-5 h-5 transition-colors duration-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            Giriş Yap
          </Link>
        </motion.div>
      ) : (
        <div className="relative">
          <motion.button
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="text-white hover:text-gray-200 transition-colors duration-300 inline-flex items-center gap-2"
          >
            <div className="w-8 h-8 rounded-full bg-blue-500/20 border border-blue-500/30 flex items-center justify-center">
              <span className="text-sm font-medium text-blue-400">
                {user?.name?.[0]?.toUpperCase() || "K"}
              </span>
            </div>
            <span className="text-sm font-medium">{user?.name}</span>
          </motion.button>

          <AnimatePresence>
            {isDropdownOpen && (
              <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                transition={{
                  duration: 0.4,
                  ease: [0.23, 1, 0.32, 1],
                }}
                className="xl:absolute xl:right-0 mt-2 w-full xl:w-48 rounded-xl bg-[#111111] backdrop-blur-sm border border-white/10 shadow-lg py-1 z-50"
              >
                <div className="px-4 py-3 border-b border-white/10">
                  <p className="text-sm text-white">
                    {user?.name || "Kullanıcı"}
                  </p>
                  <p className="text-xs text-gray-400 truncate">
                    {user?.email || "kullanici@email.com"}
                  </p>
                </div>
                <button
                  onClick={handleLogout}
                  className="w-full text-left px-4 py-2 text-sm text-red-400 hover:bg-white/5 transition-colors duration-300 inline-flex items-center gap-2"
                >
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                    />
                  </svg>
                  Çıkış Yap
                </button>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      )}
    </div>
  );
};

export default Login;
